/* eslint-disable array-callback-return */
import React from "react";
import WidgetHeader from "components/WidgetHeader/index";
import Fab from '@material-ui/core/Button';

import { sortableContainer, sortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';

import icon_realtime from "assets/images/icon-realtime.png";
import icon_check from "assets/images/icon-check.png";
import icon_move from "assets/images/icon-move.png";
import ReactTooltip from 'react-tooltip';
import IntlMessages from "util/IntlMessages";

const kpi_details = {
    I: {
        name: "I",
        img: <img src={icon_realtime} alt="I" />,
        icon: <img src={icon_check} alt="I" />
    },
};

const DateListComp = React.memo(({
    available_dates,
    sorted_dates,
    // sorted_array_dates,
    set_sorted_dates,
    select_date,
    selected_dates,
    fetching_actigraph,
    // set_sorted_array_dates
}) => {

    if (!available_dates || (available_dates && available_dates.length === 0)) {
        return null;
    }

    const onSortEnd = ({ oldIndex, newIndex }) => {
        set_sorted_dates(arrayMove(sorted_dates, oldIndex, newIndex));

        // let sorted_array_kpis_keys = Object.keys(sorted_array_dates);
        // let sorted_array_kpis_values = Object.values(sorted_array_dates);
        // sorted_array_kpis_keys = arrayMove(sorted_array_kpis_keys, oldIndex, newIndex);
        // sorted_array_kpis_values = arrayMove(sorted_array_kpis_values, oldIndex, newIndex);
        // let final_sorted_array_kpis = mergeArrToJSON(sorted_array_kpis_keys, sorted_array_kpis_values);

        // set_sorted_array_dates(final_sorted_array_kpis);
    };

    // const mergeArrToJSON = (array1, array2) => array1
    //     .map((item, i) => ({ [item]: array2[i] }))
    //     .reduce((json, val) => Object.assign({}, json, val));

    const SortableContainer = sortableContainer(({ children }) => (
        <ul className="list-inline list-inline-3" style={{ maxHeight: "400px" }}>
            {children}
        </ul>
    ));

    const SortableItem = sortableElement(({ date }) => {
        return (
            <li key={date} date_name={date} className="list-inline-item filter-item">
                <Fab disabled={fetching_actigraph} variant="contained" disableRipple={true} disableFocusRipple={true} className={`${selected_dates[date] ? "bg-blue text-white" : ""}`} classes={{ label: 'kpi-label' }} onClick={() => select_date(date)}>
                    <span data-tip data-for={`tooltip-drag-btn-${date}`} className="icon">
                        <img alt="Drag" src={icon_move} />
                    </span>
                    <span className="filter-icon">
                        {
                            kpi_details.I.img
                        }
                    </span>
                    <span className="filter-text beta-hr">
                        {date}
                    </span>
                    <span className="check-icon">{kpi_details.I.icon}</span>
                </Fab>
                <ReactTooltip id={`tooltip-drag-btn-${date}`} className='graph-tooltip beta-hr' place="right">
                    <IntlMessages id="kpi.dragMsg"></IntlMessages>
                </ReactTooltip>
            </li>
        );
    });

    return (
        <div className="jr-entry-sec mt-3">
            {
                sorted_dates
                && sorted_dates.length > 0
                && (
                    <>
                        <WidgetHeader title="Available Dates" />
                        <SortableContainer distance={10} onSortEnd={onSortEnd}>
                            {
                                sorted_dates.map((date, index) => {
                                    return (
                                        <SortableItem key={`item-${date}`} index={index} date={date} />
                                    )
                                })
                            }
                        </SortableContainer>
                    </>
                )
            }
        </div>
    )
});

export default DateListComp